import React, { Fragment, useRef, useState } from 'react';
import Topbar from './Topbar';
import { useNavigate } from 'react-router-dom';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import { Helmet } from 'react-helmet';
import { Dialog, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import instantSupportDialogIcon from '../../assets/images/instantSupportDialogIcon.svg';
import { getPathForInstantSupport, errorToast } from '../../utils/helper';
// import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';

const GetSupport = () => {
  const [open, setOpen] = useState(false);
  const [employeeCount, setEmployeeCount] = useState(10);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const cancelButtonRef = useRef(null);

  const [isAnnual, setIsAnnual] = useState(true);
  const [openPlan, setOpenPlan] = useState('telephonic');

  const navigate = useNavigate();

  const plans = {
    telephonic: {
      title: 'Telephonic EAP',
      price: 1.10,
      priceAnnually: 14.5,
      planRequirements: [
        '24/7, 365 telephone counselling and advice line',
        'Up to 6 structured counselling sessions per issue per year',
        'In-the-moment support between counselling sessions',
        'Personal financial/debt support through Auriga',
        'Legal advice through Irwin Mitchell',
        'Critical incident advice and telephone support',
        'Support for those with care responsibilities'
      ]
    },
    face: {
      title: 'Face to Face & Video Services EAP', // Face to Face & Video Services EAP
      price: 1.35,
      priceAnnually: 23.0,
      planRequirements: [
        'Includes all Telephonic EAP benefits',
        'Access to telephone, virtual, or face-to-face counselling',
        '10% discount on our B2B Premium plan'
      ]
    },
    rise: {
      title: 'Shoorah RISE Plan', // Shoorah RISE Plan
      price: 2.75,
      priceAnnually: 46.0,
      planRequirements: [
        'Includes all Face-to-Face & Video Services EAP benefits',
        'Enhanced psychological assessments, complex case support, CBT, and EMDR therapy',
        'Access to enhanced psychological assessments, complex case support and complex case management when deemed clinically appropriate. This includes CBT and EMDR therapy.',
        'Full case management for maximised clinical outcomes',
        '24/7, 365 health and wellbeing advice',
        'Online GP consultation services',
        'Full Premium access to our App and B2B suite'
      ]
    }
  };

  const handleUpgrade = () => {
    //console.log("selectedPlan in the options & EMP COUNT", selectedPlan, employeeCount);
    const selectionDetails = {
      planName: selectedPlan,
      planTitle: plans[selectedPlan].title,
      isAnnualPlan: isAnnual,
      employeeCount: parseInt(employeeCount),
      planRequirements: plans[selectedPlan]?.planRequirements,
      planPrice: isAnnual ? plans[selectedPlan]?.priceAnnually : plans[selectedPlan]?.price
    };

    navigate(getPathForInstantSupport('/instant-support/checkout'), {
      state: selectionDetails
    });
  };

  const toggleRequirements = (plan) => {
    setOpenPlan(openPlan === plan ? null : plan);
  };

  return (
    <div className="relative lg:pl-5 lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>B2B | Get Support</title>
      </Helmet>
      <Topbar title={'Instant Support (EAP)'} infoBtn={false} />

      <div className="flex flex-col w-full max-w-4xl mt-12 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
        
        <div className="flex items-center justify-start mb-8">
          <div
            className="relative flex bg-white dark:bg-shoorah-badgeText border-gray-300 border rounded-full w-40 p-1 sm:w-48 md:w-56 lg:w-80 cursor-pointer"
            onClick={() => setIsAnnual(!isAnnual)}
          >
            {/* Toggle Background */}
            <div
              className={`absolute top-1 bottom-1 w-[48.5%] bg-black dark:bg-shoorah-inputBackground rounded-full transition-all ${
                isAnnual ? 'translate-x-0' : 'translate-x-full'
              }`}
            ></div>

            {/* Text Container */}
            <div className="relative text-xs py-2 z-10 flex w-full">
              {/* Annually Text */}
              <div className="w-1/2 flex items-center justify-center">
                <span
                  className={`transition-colors ${
                    isAnnual ? 'text-white dark:text-black' : 'text-black dark:text-white'
                  }`}
                >
                  Annually
                </span>
              </div>

              {/* Monthly Text */}
              <div className="w-1/2 flex items-center justify-center">
                <span
                  className={`transition-colors ${
                    !isAnnual ? 'text-white dark:text-black' : 'text-black dark:text-white'
                  }`}
                >
                  Monthly
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row mb-2 justify-between">
          <p className="text-xl font-medium text-gray-900 dark:text-white">Select an add-on plan</p>
          <a
            href="mailto:info@shoorah.io"
            className="px-3 sm:px-4 py-1.5 text-xs sm:text-sm bg-shoorah-secondary text-white border border-white font-medium rounded-full sm:mt-0 w-auto inline-flex items-center justify-center h-auto"
          >
            Speak to Sales?
          </a>
        </div>

        {/* telephonic plan */}

        <div className="w-full mx-auto mt-2 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
          {/* Employee Count Input */}
          <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-3">
            <label className="text-gray-700 dark:text-gray-300 font-medium text-sm text-left sm:text-left">
              How many employees do you wish to add to this plan?
            </label>

            <input
              type="number"
              className="p-2 border text-center border-shoorah-secondary active:shadow-shoorah-secondary dark:border-gray-600 rounded-lg text-gray-900 dark:text-gray-200 bg-white dark:bg-gray-800 w-full sm:w-16 h-9"
              value={employeeCount}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d+$/.test(value) && parseInt(value, 10) > 0) {
                  setEmployeeCount(value);
                } else {
                  errorToast('Please enter a valid natural number');
                  setEmployeeCount('');
                }
              }}
              placeholder="10"
            />
          </div>

          <div className="space-y-0 divide-y divide-gray-200 dark:divide-gray-700">
            <div>
              <label
                key={'one'}
                className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                onClick={() => {
                  toggleRequirements('telephonic');
                  setOpenPlan('telephonic');
                  setSelectedPlan('telephonic');
                }}
              >
                <div className="flex items-center w-full sm:w-auto">
                  <input
                    type="radio"
                    name="plan"
                    className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                    checked={selectedPlan === 'telephonic'}
                    onChange={() => setSelectedPlan('telephonic')}
                  />
                  <span className="text-base font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                    {plans.telephonic.title}
                  </span>
                </div>
                <div className="flex-1 text-left sm:text-right">
                  <div className="text-gray-900 font-semibold  dark:text-gray-400 text-sm sm:text-xl">
                    <span className="text-lg sm:text-2xl ">£</span>
                    {isAnnual
                      ? plans.telephonic.priceAnnually.toFixed(2)
                      : plans.telephonic.price.toFixed(2)}{' '}
                    +VAT <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                  </div>
                </div>
              </label>

              <div className="h-[0.5px] mx-5 bg-gray-200"></div>

              {/* Requirements Dropdown */}
              <div
                className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                onClick={() => toggleRequirements('telephonic')}
              >
                <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                  Requirements
                </span>
                <button>
                  {openPlan === 'telephonic' ? (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                    >
                      <path
                        d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                        stroke="#313B6B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                    >
                      <path
                        d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                        stroke="#313B6B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              </div>

              {openPlan === 'telephonic' && (
                <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                  {plans.telephonic.planRequirements.map((text, index) => (
                    <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                      <img
                        src={instantSupportTick}
                        alt="DropdownIcon"
                        className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                      />
                      <span className="text-[#606060] dark:text-gray-300">{text}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* face to face */}

        <div className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
          <div className="space-y-0 divide-y divide-gray-200 dark:divide-gray-700">
            <div>
              <label
                className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                onClick={() => {
                  toggleRequirements('face');
                  setOpenPlan('face');
                  setSelectedPlan('face');
                }}
              >
                <div className="flex items-center w-full sm:w-auto">
                  <input
                    type="radio"
                    name="plan"
                    className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                    checked={selectedPlan === 'face'}
                    onChange={() => setSelectedPlan('face')}
                  />
                  <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                    {plans.face.title}
                  </span>
                </div>
                <div className="flex-1 text-left sm:text-right">
                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                    <span className="text-lg sm:text-2xl ">£</span>
                    {isAnnual ? plans.face.priceAnnually : plans.face.price} +VAT{' '}
                    <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                  </div>
                </div>
              </label>

              <div className="h-[0.5px] mx-5 bg-gray-200"></div>

              <div
                className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                onClick={() => toggleRequirements('face')}
              >
                <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                  Requirements
                </span>
                <button>
                  {openPlan === 'face' ? (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                    >
                      <path
                        d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                        stroke="#313B6B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                    >
                      <path
                        d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                        stroke="#313B6B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              </div>

              {openPlan === 'face' && (
                <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                  {plans.face.planRequirements.map((text, index) => (
                    <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                      <img
                        src={instantSupportTick}
                        alt="DropdownIcon"
                        className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                      />
                      <span className="text-[#606060] dark:text-gray-300">{text}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* rise plan */}

        <div className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
          <div className="space-y-0 divide-y divide-gray-200 dark:divide-gray-700">
            <div>
              <label
                className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                onClick={() => {
                  // for rise
                  toggleRequirements('rise');
                  setOpenPlan('rise');
                  setSelectedPlan('rise');
                }}
              >
                <div className="flex items-center w-full sm:w-auto">
                  <input
                    type="radio"
                    name="plan"
                    className="form-radio h-3 w-3 sm:h-5 sm:w-5 text-shoorah-primary dark:text-shoorah-secondary"
                    checked={selectedPlan === 'rise'}
                    onChange={() => setSelectedPlan('rise')}
                  />
                  <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                    {plans.rise.title}
                  </span>
                </div>
                <div className="flex-1 text-left sm:text-right">
                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                    <span className="text-lg sm:text-2xl ">£</span>
                    {isAnnual ? plans.rise.priceAnnually : plans.rise.price} +VAT{' '}
                    <span className="font-normal">{isAnnual ? '/yr' : '/month'}</span>
                  </div>
                </div>
              </label>

              <div className="h-[0.5px] mx-5 bg-gray-200"></div>

              <div
                className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer"
                onClick={() => toggleRequirements('rise')}
              >
                <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-8">
                  Requirements
                </span>
                <button>
                  {openPlan === 'rise' ? (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200"
                    >
                      <path
                        d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                        stroke="#313B6B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 sm:mr-8 ml-2 h-5 w-5 transition-transform duration-200 rotate-180"
                    >
                      <path
                        d="M3.75 11.625C3.75 11.625 6.858 6.375 9 6.375C11.1412 6.375 14.25 11.625 14.25 11.625"
                        stroke="#313B6B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              </div>

              {openPlan === 'rise' && (
                <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-12">
                  {plans.rise.planRequirements.map((text, index) => (
                    <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                      <img
                        src={instantSupportTick}
                        alt="DropdownIcon"
                        className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                      />
                      <span className="text-[#606060] dark:text-gray-300">{text}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <button
          onClick={() => handleUpgrade()}
          className={`w-full sm:w-[240px] p-2 mt-4 text-sm font-normal rounded-full border shadow-sm ${
            !employeeCount || !selectedPlan
              ? 'bg-shoorah-inputBackground dark:bg-slate-400 text-black cursor-not-allowed border-shoorah-bodyBackground'
              : 'bg-shoorah-active dark:bg-shoorah-secondary text-white cursor-pointer border-shoorah-active'
          }`}
          disabled={!employeeCount || !selectedPlan}
        >
          Purchase Plan
        </button>
      </div>

      {/* UI ENDS HERE  Dialoge BOX here now*/}

      <Transition.Root appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                  <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-none p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                    <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                      <Dialog.Title
                        as="h3"
                        className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                      >
                        <img
                          src={instantSupportDialogIcon}
                          alt="DropdownIcon"
                          className="dark:invert mx-auto"
                        />
                      </Dialog.Title>
                    </div>
                    <div>
                      <p className="text-lg text-gray-700 dark:text-gray-300">
                        Your payment is currently under review. This process typically <br /> takes
                        24-48 hours. We’ll notify you as soon as it’s completed.
                      </p>
                      <Link
                        className="w-[173px] h-[40px] bg-[#4A56DB] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer flex items-center justify-center mx-auto mt-6"
                        onClick={() => setOpen(false)}
                      >
                        Got It
                      </Link>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default GetSupport;
